/* @flow */

import type { ManageClock, ManageCanvas, StepFunc } from './Common';

export default class ClockManager implements ManageClock {
  canvasManager: ManageCanvas;
  desiredFPS = 60;
  desiredFPSdelay = 1000 / this.desiredFPS;

  // menu subs
  onStepInput = [];

  // level subs
  onStepHero = [];
  onStepUmbrella = [];
  onStepParticle = [];
  onStepGoal = [];
  onStepLevel = [];

  constructor() {
    // bootstrap game loop
    this.step();
  }
  cleanup() {
    this.onStepHero = [];
    this.onStepUmbrella = [];
    this.onStepParticle = [];
    this.onStepGoal = [];
    this.onStepLevel = [];
  }

  subscribeInput(newListener: StepFunc) {
    this.onStepInput.push(newListener);
  }
  subscribeHero(newListener: StepFunc) {
    this.onStepHero.push(newListener);
  }
  subscribeUmbrella(newListener: StepFunc) {
    this.onStepUmbrella.push(newListener);
  }
  subscribeParticle(newListener: StepFunc) {
    this.onStepParticle.push(newListener);
  }
  subscribeGoal(newListener: StepFunc) {
    this.onStepGoal.push(newListener);
  }
  subscribeLevel(newListener: StepFunc) {
    this.onStepLevel.push(newListener);
  }
  step() {
    this.onStepInput.forEach(listenerFunc => listenerFunc());
    this.onStepHero.forEach(listenerFunc => listenerFunc());
    this.onStepUmbrella.forEach(listenerFunc => listenerFunc());
    this.onStepParticle.forEach(listenerFunc => listenerFunc());
    this.onStepGoal.forEach(listenerFunc => listenerFunc());
    this.onStepLevel.forEach(listenerFunc => listenerFunc());

    window.setTimeout(() => this.step(), this.desiredFPSdelay);
  }
  onKeyDown = (event: *) => {};
}



// WEBPACK FOOTER //
// ./src/ClockManager.js